import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AppInitService {
  private initialized$ = new BehaviorSubject<boolean>(false);

  isInitialized(): Observable<boolean> {
    return this.initialized$.asObservable();
  }

  setInitialized(): void {
    this.initialized$.next(true);
  }
}
